import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { type AIAnswerTab } from '../constants';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onAIAnswerTabClick: (
	props: commonAttributesType & {
		selectedTab: AIAnswerTab;
	},
) => AnalyticsEventPayload = (
	props: commonAttributesType & {
		selectedTab: AIAnswerTab;
	},
): AnalyticsEventPayload => {
	const { query, answerString, source, selectedTab } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerTab',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			selectedTab,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
